import { render, staticRenderFns } from "./NowhowModal.vue?vue&type=template&id=be8e06ba&scoped=true"
import script from "./NowhowModal.vue?vue&type=script&lang=ts"
export * from "./NowhowModal.vue?vue&type=script&lang=ts"
import style0 from "./NowhowModal.vue?vue&type=style&index=0&id=be8e06ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8e06ba",
  null
  
)

export default component.exports